// Base URL for static assets served from Cloudflare-fronted storage.
const ASSETS_URL = process.env.REACT_APP_ASSETS_URL || 'https://assets.top-spin.ro'

// Shared logo URLs so every surface renders the same cloud-hosted artwork
// (single source of truth — no per-file literals or local copies to drift).
const WHITE_LOGO_URL = `${ASSETS_URL}/images/logo_white.svg`

export { ASSETS_URL, WHITE_LOGO_URL }
